import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  index?: number;
  showCover?: boolean;
}

export default function NewsCard({
  item,
  index = 0,
  showCover = false,
}: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-accent-300 hover:bg-accent-50 sm:flex-row"
      style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.05}s both` }}
    >
      {showCover ? (
        <div
          className="h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-auto sm:w-56"
          style={{ aspectRatio: "8 / 5" }}
        >
          <img
            src={item.cover}
            alt={`${item.title}配图`}
            title={`${item.title}`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      ) : null}
      <div className="flex flex-1 flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
            {item.category}
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-calendar-line" aria-hidden="true" />
            {item.date}
          </span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-auto flex items-center gap-1 pt-1 text-xs font-medium text-primary-700">
          阅读全文
          <i
            className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </span>
      </div>
    </Link>
  );
}